import React from "react"
import autobind from "class-autobind"
import { Chart, ChartOptions, ChartPoint } from "chart.js"
import moment from "moment"
import { ETrendTimeScope, ETrendUnitType, IGroupedTrend, ITrendSettingsDocument } from "../../../models/data/dashboard/Trends/TrendsData"
import * as utils from "../../../helpers/utils"

export interface IProps {
    groupedTrend: IGroupedTrend
    scope: ETrendTimeScope
    settings: ITrendSettingsDocument,
    value: number
}

export interface IState {
    chartId: string
}

export default class TrendSummaryTrendLine extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            chartId: this.props.groupedTrend.Id,
        }

        autobind(this)
    }

    trend_line_chart
    componentDidMount() {
        this.loadChart()
    }

    componentDidUpdate() {
        //this.loadChart()
    }

    loadChart() {
        let line = utils.getTrendColorGreen(); 
        let gradient1 = utils.getTrendColorGreenGradient1()
        let gradient2 = utils.getTrendColorGreenGradient2()
        const negativeGrowthPreferred = this.props.settings.AggregationSettings.NegativeGrowthPreferred

        if((negativeGrowthPreferred && this.props.value > 0) || (!negativeGrowthPreferred && this.props.value < 0)){
            line = utils.getTrendColorRed() 
            gradient1 = utils.getTrendColorRedGradient1()
            gradient2 = utils.getTrendColorRedGradient2()
        }   

        if(this.props.settings.UnitType === ETrendUnitType.Percentage){
            if(this.props.value < this.props.settings.ThresholdLowerLimit || this.props.value > this.props.settings.ThresholdUpperLimit){
                line = utils.getTrendColorRed(); 
                gradient1 = utils.getTrendColorRedGradient1();
                gradient2 = utils.getTrendColorRedGradient2();    
            }else{
                line = utils.getTrendColorGreen(); 
                gradient1 = utils.getTrendColorGreenGradient1();
                gradient2 = utils.getTrendColorGreenGradient2();        
            }
        }
                

        if (typeof this.trend_line_chart !== "undefined") {
            this.trend_line_chart.destroy()
        }

        if(!this.props.groupedTrend || !this.props.groupedTrend.SeriesData || this.props.groupedTrend.SeriesData.length < 1){
            return
        }

        const ctx: HTMLCanvasElement = document.getElementById(this.state.chartId) as HTMLCanvasElement
        const canvas = ctx.getContext("2d")

        var gradient = canvas.createLinearGradient(0, 0, 0, 75)
        gradient.addColorStop(0, gradient1)
        gradient.addColorStop(1, gradient2)
        
        const data: ChartPoint[] = this.props.groupedTrend.SeriesData.map((item) => ({y: item.Value, x: moment(item.DateTime).format("YYYY-MM-DD")}))

//        console.log("summary chart data:")
//        console.log(data)

        //Even though we aren't displaying labels, we have to have them for the graph to work
        const chart_data = { 
            labels: this.props.groupedTrend.SeriesData.map((item) => moment(item.DateTime).format("YYYY-MM-DD")), 
            datasets: [{
                label: this.props.groupedTrend.Settings.Name,
                backgroundColor: gradient, 
                borderColor: line,
                pointBorderWidth: 0,
                data: data,
                tension: 0,
            }] 
        }

        let axisList = []

        axisList.push({
            id: "y_axis",
            position: "left",
            ticks: {
                min: 0,
                maxTicksLimit: 7,
                fontColor: "#ffffff"
            },
            gridLines: {
                display: false
            },
            display: false,
        })        
            
        if ((this.props.groupedTrend && this.props.groupedTrend.SeriesData.length > 0)) {
            const chart_options: ChartOptions = {
                responsive: true,
                elements: {
                    point:{
                        radius: 0
                    }
                },                
                scales: {
                    scaleLabel: {
                        fontColor: "#ffffff",
                    },
                    yAxes: axisList,
                    xAxes: [
                        {
                            display: false,
                            gridLines: {
                                display: false
                            }
                        }
                    ]
                },
                legend: {
                    display: false
                },
                tooltips: {
                    enabled: false
                }
            }
            
            this.trend_line_chart = new Chart(ctx, {
                data: chart_data,
                options: chart_options,
                type: "line"
            })
        }
    }

    render() {
        return (
            <div style={{paddingTop: 5, paddingBottom: 5}}>
                <canvas id={this.state.chartId} style={{maxHeight: 50}}/>
            </div>
        )
    }
}
